import { StreamSpecifier } from '@cotera/api';
import { Identity } from '../graph/types';

export const streamIdFromSpecifier = (
  specifier: Extract<StreamSpecifier, { t: 'graph' }>
): string => {
  return Identity.fromTuple(specifier.colIdentity).toString();
};

export const entityNameFromSpecifier = (
  specifier: Extract<StreamSpecifier, { t: 'graph' }>
): string => {
  return Identity.fromTuple(specifier.relIdentity).toString();
};
